<template>
  <role-edit onboarding :admin="false" />
</template>

<script>
import RoleEdit from '../RoleEdit'
export default {
  components: { RoleEdit }
}
</script>

<style></style>
